import {
  getCountForFieldEQLFunction,
  getFieldNameFromEqlField,
} from '@modules/common/utils';
import { useQuantifyStore } from '@modules/quantify/store/quantifyStore';
import { useCallback, useRef } from 'react';
import { EQLFunction, EQLFunctionName } from 'v2/core/repository/eql/types';
import { shallow } from 'zustand/shallow';

export function useAddPaginationFunctionIfRequired() {
  const state = useQuantifyStore(({ query, visual }) => {
    return {
      shouldShowAllValues: visual.shouldShowAllValues,
      shouldShowTopDataPoints: query.shouldShowTopDataPoints,
      topDataPointsSelectionCount: query.topDataPointsSelectionCount,
      visibleDataPoints: query.visibleDataPoints,
      pageNumber: visual.pageNumber,
      compareTo: query.compareQuery,
      groupBy: query.groupByField,
    };
  }, shallow);

  const eqlFieldName = state.groupBy
    ? getFieldNameFromEqlField(state.groupBy)
    : undefined;
  const countForLabelsFunc = getCountForFieldEQLFunction(eqlFieldName);
  const shouldUseCountForFunction =
    !state.shouldShowAllValues &&
    !state.shouldShowTopDataPoints &&
    countForLabelsFunc;

  const dependencies = { ...state, shouldUseCountForFunction };
  const dependenciesRef = useRef(dependencies);
  dependenciesRef.current = dependencies;

  return useCallback((functions: EQLFunction[]) => {
    if (!dependenciesRef.current.shouldUseCountForFunction) {
      const pageSize = dependenciesRef.current.shouldShowAllValues
        ? 100
        : dependenciesRef.current.shouldShowTopDataPoints
        ? dependenciesRef.current.topDataPointsSelectionCount
        : dependenciesRef.current.visibleDataPoints?.length;

      functions.push({
        name: dependenciesRef.current.compareTo
          ? EQLFunctionName.DeltaPaginate
          : EQLFunctionName.Paginate,
        params: [pageSize ?? 10, dependenciesRef.current.pageNumber],
      });
    }
  }, []);
}
